"use strict";
exports.__esModule = true;
var react_1 = require("react");
var DEFAULT_EVENTS = ['mousedown', 'touchstart'];
var useClickOutside = function (onClickOutside, ref, events) {
    if (events === void 0) { events = DEFAULT_EVENTS; }
    var savedCallback = react_1.useRef(onClickOutside);
    react_1.useEffect(function () {
        savedCallback.current = onClickOutside;
    }, [onClickOutside]);
    react_1.useEffect(function () {
        var listener = function (event) {
            if (!event.defaultPrevented &&
                ref.current &&
                !ref.current.contains(event.target)) {
                savedCallback.current(event);
            }
        };
        events.forEach(function (event) { return document.addEventListener(event, listener); });
        return function () {
            events.forEach(function (event) { return document.removeEventListener(event, listener); });
        };
    }, [ref, events]);
};
exports["default"] = useClickOutside;
//# sourceMappingURL=useClickOutside.js.map